import React from 'react'
import { useTranslation } from 'react-i18next'
import Images from '../../assets/images'
import './Payment.css'

const Payment = () => {
  const { t } = useTranslation()
  const benefits = t('academyPayment.benefits', { returnObjects: true }) || []

  return (
    <section className='academy-payment' id='pricing'>
      <div className='academy-payment-content'>
        <div className='academy-payment-left'>
          <h2>
            {t('academyPayment.title')}
            <span>{t('academyPayment.titleHighlight')}</span>
          </h2>

          <p className='description'>{t('academyPayment.description')}</p>
          <p className='cancelAnytime'>{t('academyPayment.cancelAnytime')}</p>

          <div className='priceBlock'>
            <p className='from'>{t('academyPayment.from')}</p>
            <div className='priceRow'>
              <span className='amount'>{t('academyPayment.amount')}</span>
              <span className='perMonth'>{t('academyPayment.perMonth')}
                <span className='perMonthHighlight'>{t('academyPayment.perMonthHighlight')}</span>
              </span>
            </div>
            <p className='priceNote'>{t('academyPayment.priceNote')}</p>
          </div>

          <button
            type='button'
            className='academy-payment-cta'
            onClick={() => window.location.href = 'mailto:hello@tiimapp.com'}
          >
            {t('academyPayment.button')}
          </button>
        </div>

        <div className='academy-payment-right'>
          <div className='academy-payment-imageWrap'>
            <img src={Images.academy.price} alt='academy payment' className='academy-payment-image' />
          </div>

          <h3>{t('academyPayment.benefitsTitle')}</h3>

          <ul>
            {benefits.map((item, index) => (
              <li key={index}>
                <img className='check' src={Images.icons.circleCheck2} alt='check' />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}

export default Payment
